import React from 'react';
import clsx from 'clsx';

import { AlertProps, ALERT_TYPE } from './Alert.types';
import { Icon } from '../Icon';

export const Alert = ({
  alertType = ALERT_TYPE.DEFAULT,
  classNames,
  headingText,
  hasIcon = true,
  icon,
  isDismissible = false,
  isGlobal = false,
  messageText,
  onCloseClick,
  testid = `alert-${alertType}`,
}: AlertProps): JSX.Element => {
  const alertClassNames = clsx(
    'alert',
    {
      alert_danger: alertType === ALERT_TYPE.DANGER,
      alert_info_dark: alertType === ALERT_TYPE.DARK,
      alert_info: alertType === ALERT_TYPE.INFO,
      alert_success: alertType === ALERT_TYPE.SUCCESS,
      alert_warning: alertType === ALERT_TYPE.WARNING,
      alert_dismissible: isDismissible,
      alert_global: isGlobal,
    },
    classNames
  );

  function getIcon(alertType: AlertProps['alertType']) {
    switch (alertType) {
      case ALERT_TYPE.DANGER:
        return 'AlertsDanger24';
      case ALERT_TYPE.INFO:
        return 'AlertsInfo24';
      case ALERT_TYPE.SUCCESS:
        return 'AlertSuccess24';
      case ALERT_TYPE.WARNING:
        return 'AlertWarning24';
      default:
        return 'AlertsTip24';
    }
  }

  const closeIconColor = alertType === ALERT_TYPE.DARK ? 'white' : null;

  return (
    <div className={alertClassNames} role='alert' data-testid={testid}>
      {/* Alert Icon */}
      {hasIcon && (
        <Icon
          className='alert_icon alert_icon--no-fill'
          icon={getIcon(alertType)}
          size={'large'}
          {...icon}
        />
      )}
      <div className='alert__container'>
        {/* Heading Text */}
        {headingText && <span className='alert__header'>{headingText}</span>}

        {/* Message Text */}
        {messageText && <span className='alert__message'>{messageText}</span>}
      </div>
      {/* Close button */}
      {isDismissible && onCloseClick && (
        <div className='alert__actions'>
          <button
            aria-label='Close'
            className='alert_close'
            type='button'
            onClick={onCloseClick}
          >
            <Icon className='icon' color={closeIconColor} icon='Close16' />
          </button>
        </div>
      )}
    </div>
  );
};
